module.exports = __webpack_public_path__ + "img/mail_b.2a3fec79.svg";